import CookieConsent, { getCookieConsentValue } from 'react-cookie-consent';
import { startGA } from '../util/analytic';

interface CustomCookieConsentProps {
  message: string;
  accept: string;
  decline: string;
  tour: any;
  loaded: boolean;
}

export const treedisCookieName = 'allow_treedis_cookie';
export const allowUsesCookie = (hide: boolean = false) => {
  const cookie = getCookieConsentValue(treedisCookieName);
  if (cookie === undefined) {
    //no value set yet for cookie
    if (hide) {
      //message is not activated, assume we can track
      return true;
    } else {
      //message is activated, so wait for user response
      return false;
    }
  } else {
    return cookie === 'true';
  }
};
export function CustomCookieConsent({ message, accept, decline, tour, loaded }: CustomCookieConsentProps) {
  return (
    <CookieConsent
      location="bottom"
      cookieName={treedisCookieName}
      style={{ background: 'rgba(0, 0, 0, 0.6)', fontFamily: 'Hind' }}
      buttonText={accept || 'Accept'}
      buttonClasses="primary-btn m-1"
      enableDeclineButton
      declineButtonText={decline || 'Decline'}
      declineButtonClasses="primary-btn black m-1"
      disableButtonStyles
      onAccept={() => {
        startGA(tour, loaded, true);
      }}
    >
      {message || 'This website uses cookies to enhance the user experience.'}
    </CookieConsent>
  );
}
